import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "utils/api";

interface Reaction {
  id: number;
  code: string;
  name: string;
}

interface ReactionData {
  reaction: Reaction;
  value: number;
}

interface ReactionChartState {
  isLoading: boolean;
  reactedChartsCounts: ReactionData[];
  includeUsers: {
    ids: number[];
  };
  includeQuestions: {
    sectionIds: number[];
    // questionIds: any[];
  };
  excludeUsers: {
    ids: number[];
  };
  error: string;
}

const initialState: ReactionChartState = {
  isLoading: false,
  reactedChartsCounts: [],
  includeUsers: {
    ids: [],
  },
  includeQuestions: {
    sectionIds: [],
    // questionIds: [],
  },
  excludeUsers: {
    ids: [],
  },
  error: "",
};

export const getReactionChartCounts = createAsyncThunk(
  "getReactionChartCounts",
  async (id: number, { getState }) => {
    try {
      const state = (getState() as { reactedChartsCounts: ReactionChartState })
        .reactedChartsCounts;
      const { includeUsers, includeQuestions } = state;
      const response = await axiosInstance.post(
        `/v1/reports/boards/${id}/reaction/chart/counts`,
        { includeUsers, includeQuestions }
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const reactionChartsCountsSlice = createSlice({
  initialState,
  name: "reactionChartCounts",
  reducers: {
    setIncludeUserReactionChartCounts: (state, { payload }) => {
      state.includeUsers.ids = payload;
    },
    setIncludeSectionsReactionChartCounts: (state, { payload }) => {
      state.includeQuestions.sectionIds = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReactionChartCounts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReactionChartCounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.reactedChartsCounts = action.payload.data;
      })
      .addCase(getReactionChartCounts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message as string;
      });
  },
});

const { actions } = reactionChartsCountsSlice;

export const {
  setIncludeUserReactionChartCounts,
  setIncludeSectionsReactionChartCounts,
} = actions;
